import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectAccountId, selectApi, serializeError, SilentThunkError } from '@socialive/common';

export default createAsyncThunk(
  'recordings/fetchStreams',
  async ({ query, options = {} }, { getState }) => {
    const api = selectApi(getState());
    if (!api) {
      throw new SilentThunkError('api is not defined');
    }

    const accountId = selectAccountId(getState());
    const { sort, page, ...opts } = options;

    const sortParam = sort ? `&sort=${sort}` : '';
    const sanitizedPage = page || '0';

    const params = new URLSearchParams({ ...opts, accountId, page: sanitizedPage }).toString();

    const response = await api(`/search/streams?q=${query}deletedAt=lt=1&${params}${sortParam}`, { silentError: true });

    return response;
  },
  { serializeError }
);
